"use client"
import { SiNaver } from "react-icons/si"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import { RiKakaoTalkFill } from "react-icons/ri"
import { KAKAO_AUTH_URL, NAVER_AUTH_URL } from "../../../constants/config"

const Login = () => {
    const naverClickEventHandler = () => {
        window.location.href = NAVER_AUTH_URL
    }

    const kakaoClickEventHandler = () => {
        window.location.href = KAKAO_AUTH_URL
    }

    return (
        <section className="pf-page">
            <PC>
                <section className="pc-login-box">
                    <div className="layout">
                        <div className="background">
                            <div className="title">
                                <img src={process.env.PUBLIC_URL + "/images/logo_b.png" || "/placeholder.svg"} alt="성실교회 로고" />
                            </div>
                            <div className="sub-title">
                                <a>로그인 후 더 다양한 메뉴를 이용하실 수 있습니다.</a>
                            </div>

                            <div className="icon-box" onClick={naverClickEventHandler}>
                                <SiNaver style={{ fontSize: "18px" }} />
                                Naver로 로그인
                            </div>

                            <div className="icon-box" onClick={kakaoClickEventHandler}>
                                <RiKakaoTalkFill style={{ fontSize: "20px" }} />
                                Kakao로 로그인
                            </div>

                            <div className="login-info">
                                <div className="divider-text">간편 로그인</div>
                                <div className="help-text">로그인에 문제가 있으신가요?</div>
                                <div className="contact-info">교회 사무실: 031-877-5591</div>
                            </div>
                        </div>
                    </div>
                </section>
            </PC>

            <Notebook>
                <section className="notebook-login-box">
                    <div className="layout">
                        <div className="background">
                            <div className="title">
                                <img src={process.env.PUBLIC_URL + "/images/logo_b.png" || "/placeholder.svg"} alt="성실교회 로고" />
                            </div>
                            <div className="sub-title">
                                <a>로그인 후 더 다양한 메뉴를 이용하실 수 있습니다.</a>
                            </div>

                            <div className="icon-box" onClick={naverClickEventHandler}>
                                <SiNaver style={{ fontSize: "16px" }} />
                                Naver로 로그인
                            </div>

                            <div className="icon-box" onClick={kakaoClickEventHandler}>
                                <RiKakaoTalkFill style={{ fontSize: "18px" }} />
                                Kakao로 로그인
                            </div>

                            <div className="login-info">
                                <div className="divider-text">간편 로그인</div>
                                <div className="help-text">로그인에 문제가 있으신가요?</div>
                                <div className="contact-info">교회 사무실: 031-877-5591</div>
                            </div>
                        </div>
                    </div>
                </section>
            </Notebook>

            <Tablet>
                <section className="tablet-login-box">
                    <div className="layout">
                        <div className="background">
                            <div className="title">
                                <img src={process.env.PUBLIC_URL + "/images/logo_b.png" || "/placeholder.svg"}
                                     alt="성실교회 로고"/>
                            </div>
                            <div className="sub-title">
                                <a>로그인 후 더 다양한 메뉴를 이용하실 수 있습니다.</a>
                            </div>

                            <div className="icon-box" onClick={naverClickEventHandler}>
                                <SiNaver style={{fontSize: "15px"}}/>
                                Naver로 로그인
                            </div>

                            <div className="icon-box" onClick={kakaoClickEventHandler}>
                                <RiKakaoTalkFill style={{fontSize: "16px"}}/>
                                Kakao로 로그인
                            </div>

                            <div className="login-info">
                                <div className="divider-text">간편 로그인</div>
                                <div className="help-text">로그인에 문제가 있으신가요?</div>
                                <div className="contact-info">교회 사무실: 031-877-5591</div>
                            </div>
                        </div>
                    </div>
                </section>
            </Tablet>

            <Mobile>
                <section className="mobile-login-box">
                    <div className="layout">
                        <div className="background">
                            <div className="title">
                                <img src={process.env.PUBLIC_URL + "/images/logo_b.png" || "/placeholder.svg"} alt="성실교회 로고" />
                            </div>
                            <div className="sub-title">
                                <a>로그인 후 더 다양한 메뉴를 이용하실 수 있습니다.</a>
                            </div>

                            <div className="icon-box" onClick={naverClickEventHandler}>
                                <SiNaver style={{ fontSize: "14px" }} />
                                Naver로 로그인
                            </div>

                            <div className="icon-box" onClick={kakaoClickEventHandler}>
                                <RiKakaoTalkFill style={{ fontSize: "16px" }} />
                                Kakao로 로그인
                            </div>

                            <div className="login-info">
                                <div className="help-text">로그인 문의: 031-877-5591</div>
                            </div>
                        </div>
                    </div>
                </section>
            </Mobile>
        </section>
    )
}

export default Login
